import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { getCitizensInfo } from '../../user/actions/GetInfo'
import { getCitizens } from '../../user/actions/citizens/GetCitizens'
import moment from 'moment-timezone'
import { connect } from 'react-redux'
import lightwallet from 'eth-lightwallet'
import {
  Container,
  Header,
  Segment,
  Message,
  Pagination,
  Table
} from 'semantic-ui-react'

class Citizens extends Component {
	
    constructor(props) {
        super(props)
    }

    componentWillMount(){
		
        let { dispatch, memberId, balanceIn, citizensNum, activePage, authData } = this.props

        if(memberId === '0' || balanceIn === '0 ETH'){
            return browserHistory.push('/city')
        }

        if (memberId !== '0' && balanceIn !== '0 ETH'){
            dispatch(getCitizens(citizensNum, activePage))	
        }

        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()

        dispatch(getCitizensInfo(address[0]))
    }

    componentWillReceiveProps(nextProps){

        let { dispatch, activePage } = this.props
 
        if(nextProps.memberId === '0' || nextProps.balanceIn === '0 ETH'){
            browserHistory.push('/city')
        }

        if (!nextProps.citizensPassed && nextProps.memberId !== '0' && nextProps.balanceIn !== '0 ETH'){
            dispatch(getCitizens(nextProps.citizensNum, activePage))	
        }
    }

    handlePaginationChange(event, { activePage }) {
			
        let { dispatch } = this.props

        dispatch(getCitizens(this.props.citizensNum, activePage.toString()))	
    }

    unixTime(unixtime) {

        return moment
			.unix(unixtime)
			.tz(moment.tz.guess())
			.format('DD/MM/YYYY HH:mm')
    }
	
    render() {

        let { memberId, balanceIn, activePage, citizensNum, citizens} = this.props

        const Citizens = ({citizens}) => (

            <Table.Body>
                {citizens.map(citizen => (
                    <Table.Row key={citizen.citizenId}>
                        <Table.Cell>{citizen.citizenId}</Table.Cell>
                        <Table.Cell>{citizen.citizenName}</Table.Cell>
                        <Table.Cell>{citizen.citizenAddress}</Table.Cell>
                        <Table.Cell>{this.unixTime(citizen.citizenSince)}</Table.Cell>
                    </Table.Row>
				))}
            </Table.Body>
        ); 
        
        if(memberId === 'N-N' || balanceIn === 'N-N'){
            return(<Segment style={{  minHeight: 700 }} vertical loading />)
        }

        if(memberId !== '0' || balanceIn !== '0 ETH'){
            return(
                <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                    <Header as='h1' content='Citizens' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}/>
                    {citizens.length === 0 ? <Container textAlign='left' text><Message error content='There are no citizens.'/></Container> :
                        <Container textAlign='left'>
                            <Table basic='very' padded celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>#</Table.HeaderCell>
                                        <Table.HeaderCell>Name</Table.HeaderCell>
                                        <Table.HeaderCell>Address</Table.HeaderCell>
                                        <Table.HeaderCell>Since</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Citizens citizens={citizens} />
                                <Table.Footer>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan='4'>
                                            <Pagination floated='right' style={{ /*marginBottom: '1em'*/ }} firstItem={null} lastItem={null} activePage={activePage} onPageChange={this.handlePaginationChange.bind(this)} totalPages={Math.ceil(citizensNum / 5)} />       
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Footer>
                            </Table>
                        </Container>
                    }
                </Segment>
				)			
        } else {
            return (null);
        }
    }
}

const mapStateToProps = (state) => {
    return {
        memberId: state.city.data.memberId,
        balanceIn: state.city.data.balanceIn,
        citizensNum: state.city.data.citizensNum,
        activePage: state.city.data.citizensPage.activePage,
        citizensPassed: state.city.data.citizensPage.citizensPassed,
        citizens: state.city.data.citizensPage.citizens
    }
}

export default connect(mapStateToProps)(Citizens)

Citizens.propTypes = {
    memberId: PropTypes.string,
    citizensNum: PropTypes.string,
    activePage: PropTypes.string,
    balanceIn: PropTypes.string,
    citizensPassed: PropTypes.bool,
    citizens: PropTypes.array,
    authData: PropTypes.object,
    dispatch: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/layouts/city/Citizens.js